import { api } from "./api";
import {
  GET_ATTENDANCE_BY_COACHING,
  MARK_ATTENDANCE,
  GET_CURRENT_CLASS_ATTENDANCE,
} from "../apiEndPoints";

export const attendanceApiSlice = api.injectEndpoints({
  endpoints: (builder) => ({
    getAttendanceByCoaching: builder.query({
      query: (student_id) => ({
        url: `${GET_ATTENDANCE_BY_COACHING}?student_id=${student_id}`,
        method: "GET",
      }),
    }),
    markAttendance: builder.mutation({
      query: (payload) => ({
        url: MARK_ATTENDANCE,
        method: "POST",
        body: payload,
      }),
    }),
    getCurrentClassAttendance: builder.query({
      query: (student_id) => ({
        url: `${GET_CURRENT_CLASS_ATTENDANCE}?student_id=${student_id}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetAttendanceByCoachingQuery,
  useMarkAttendanceMutation,
  useGetCurrentClassAttendanceQuery,
} = attendanceApiSlice;
